module.exports = __webpack_public_path__ + "static/img/soumission-sachet.5c5702b5.jpg";